import { RootState } from "../..";
import { CurrentTicker, TickerInfo } from "./types";

export const selectAllTickers = (state: RootState): TickerInfo => state.public.tickersAll.tickers;
export const selectAllTickersLoading = (state: RootState): boolean => state.public.tickersAll.loading;
export const selectGroupTickers = (state: RootState): string[] => state.public.tickersGroup.tickers;
export const selectGroupTickersLoading = (state: RootState): boolean => state.public.tickersGroup.loading;
export const selectCurrentTicker = (state: RootState): CurrentTicker=> state.public.tickersAll.currentTicker;
export const selectGroup = (state: RootState): string => state.public.tickersGroup.group;